import styled from "styled-components";
import React from "react";

const ScrollDiv = styled.div`
  overflow-y: auto;
  scrollbar-width: auto;
  scrollbar-color: rgba(0, 0, 0, 0.5);
  padding-bottom: 0px !important;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
  }

  .MuiDialogContent-root {
    overflow: unset;
  }
`;

const useScrollBox = (children) => {
  return <ScrollDiv>{children}</ScrollDiv>;
};

export default useScrollBox;
